module.exports = __webpack_public_path__ + "static/img/tip5.1633659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tip5.png
// module id = yw09
// module chunks = 1